import React, { FC, useMemo } from 'react'
import { Form } from 'react-bootstrap'
import '../../../components/kyc/kycStyle.css'

import { FaStarOfLife } from 'react-icons/fa'

interface Option {
  value: string
  label: string
}

interface SearchBySelectProps {
  required?: boolean
  options: Array<Option>
  onChangeHandler: (value: string) => void
  className?: string
  selectClassName?: string
  disabled?: boolean
}

export const SearchBySelect: FC<SearchBySelectProps> = ({
  options,
  required,
  onChangeHandler,
  className,
  selectClassName,
  disabled,
}) => {
  const [value, setValue] = React.useState('')

  return (
    <Form.Group className={`${className}`} style={{ maxWidth: '430px' }}>
      <Form.Select
        className={`custom-input dropdown ${selectClassName} default`}
        aria-label="Search by"
        placeholder="Search By"
        value={value}
        onChange={(e) => {
          setValue(e.target.value)
          onChangeHandler(e.target.value)
        }}
        disabled={disabled}
      >
        {options.map(({ value, label }) => (
          <option
            key={value}
            value={value}
            className={`${value === '' ? 'grey' : ''}`}
          >
            {label}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  )
}

export default SearchBySelect
